import React from 'react';

export default function FieldHelp({
    children
}) {
    if (!children) return null;
    return (
        <p className="text-[11px] leading-snug text-muted-foreground mt-0.5">
            {children}
        </p>
    );
}
